
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Werner K., 66, verstorben am 8. November 2020</b>
    <br />
    <br />
    <i>Seine Tochter sagt:</i>
    <br />
    <p>
  «Wir haben in unserer Familie sehr viel Vertrauen in die Massnahmen des
  Bundesrats. Das war vor dem Tod meines Vaters genauso wie jetzt danach.
    </p>
    <p>
  Schlimm waren für uns aber die Debatten, die sich darum entwickelten. Manche
  sagten, man müsse jetzt mit dem Tod leben. Die Leute sterben halt. Andere
  Generationen hätten ja Kriege gehabt.
    </p>
    <p>
  Ich habe grosse Mühe, wie unser Leid damit gegen das von anderen aufgewogen
  wird. Als wäre der Tod austauschbar. Es war schlimm, unseren Vater zu
  verlieren. Er war 66. Aber für eine andere ist es genauso schrecklich, den
  85-jährigen Mann zu verlieren. Das Alter spielt keine Rolle, wenn es um einen
  geliebten Menschen geht.
    </p>
    <p>
  Solche Vergleiche, mitten in einer Pandemie – das kann man einfach nicht
  machen.
    </p>
    <p>
  Das Coronavirus ist etwas, gegen das man sich schützen kann. Es überfällt
  einen nicht wie Krebs oder ein Herzinfarkt. Doch wirklich schützen können wir
  uns nur, wenn alle die Massnahmen des Bundesrats mittragen. Wenn man aber
  dagegen ankämpft, ist das egoistisch. Es ist eine Ellbogentaktik, und die
  Schwächsten zahlen den Preis dafür. So wie mein Vater, der eine Vorerkrankung
  hatte.
    </p>
    <p>
  Unsere Spitäler kommen an den Anschlag. Als mein Vater nach seiner Ansteckung
  Probleme hatte, sagte man uns im Spital, sie seien überlastet. Er könne nur
  kommen, wenn er akute Atemnot habe. Diese Situation ist nicht nur für die
  Patienten und deren Angehörige tragisch, sondern vor allem auch für das
  Pflegepersonal und die Ärzte – das darf in einem Land wie der Schweiz nicht
  sein!»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;